import type { BasicInfoNavigationEntry, BasicInfoState } from "./types";

export function buildBasicInfoNavigationStack(
  state: BasicInfoState,
  gender?: "AFAB" | "AMAB" | null,
): BasicInfoNavigationEntry[] {
  const stack: BasicInfoNavigationEntry[] = [
    { name: "SexAtBirth" },
    { name: "BasicInfo" },
    { name: "QuickExposure" },
  ];

  if (gender === "AFAB") {
    stack.push({ name: "Pregnancy" });
    stack.push({ name: "Endometriosis" });
    stack.push({ name: "PCOS" });
  }

  if (gender === "AMAB") {
    stack.push({ name: "Varicocele" });
  }

  stack.push({ name: "Cancer" });
  stack.push({ name: "Allergies" });
  if (state.hasAllergies === true) {
    stack.push({ name: "AllergiesDetails" });
  }

  stack.push({ name: "Medications" });

  stack.push({ name: "AboutYouComplete" });

  return stack;
}
